import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import DynamicComponent from '../Components/DynamicComponent';

const PriceHistoryContainer = DynamicComponent({
  loader: () => import('../Components/PriceHistory/PriceHistoryContainer'),
});

// Mounts the price-history button/overlay into every .js-price-history span found
// within `root`. Server renders the span empty; the button is React-injected here.
// Callable repeatedly (initial bootstrap, and again per ProductSlider once its slides
// are in the DOM) — ReactDOM.render reconciles, so re-runs are idempotent and any
// static button copied into a slide via innerHTML is replaced by a live React one.
export const mountPriceHistory = (root, store) => {
  if (!root) return;

  root.querySelectorAll('.js-price-history').forEach((mount) => {
    const { pricehistory, overlayId } = mount.dataset;
    if (!pricehistory) return;

    ReactDOM.render(
      <Provider store={store}>
        <PriceHistoryContainer {...JSON.parse(pricehistory)} overlayId={overlayId} />
      </Provider>,
      mount
    );
  });
};
